<template>
  <div class="row">
    <div class="col-12 col-sm col-12 evidence-container">
      <div class="row">
        <div class="col">
          <TitleBreadCrumb :page="page" />
        </div>
        <div class="col-1 col-sm col-12 mt-4 text-right">
          <ActionButton
            variant="outline-success mr-2"
            i="fas fa-arrow-circle-left"
            text="Regresar"
            @click="() => $router.back()"
          />
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-12">
          <RLVEvidenceAdvancedSearch @searchHandler="search($event, true)" />
        </div>
      </div>

      <RLVEvidenceResults
        :results="results"
        :total-item-count="pagination.totalItemCount"
        :page-size="pageSize"
        :page-count="pagination.pageCount"
        :count="pagination.count"
        :current-page="pagination.currentPage"
        :refresh-page="refreshPage"
        @pagination-go-page="goToPage"
        @refresh-search="refreshSearch"
      />
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';
import RLVEvidenceAdvancedSearch from '@/views/student/RLVEvidences/components/RLVEvidenceAdvancedSearch';
import RLVEvidenceResults from '@/views/student/RLVEvidences/components/RLVEvidenceResults';
import ActionButton from '@/components/common/ActionButton';
import storeMixin from '@/mixin/storeGenerator';
export default {
  name: 'RLVEvidence',
  components: {
    TitleBreadCrumb,
    SectionTitle,
    RLVEvidenceAdvancedSearch,
    RLVEvidenceResults,
    ActionButton,
  },
  mixins: [storeMixin],
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Informes Rosa Lydia Vélez',
        routes: ['Inicio', 'Estudiante', 'Informes Rosa Lydia Vélez'],
      },
      results: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
      },
      pageSize: 10,
      filters: {},
      refreshPage: false,
    };
  },
  methods: {
    async search(vm, resetPage) {
      this.refreshPage = false;
      this.filters = vm;

      vm.pageIndex = resetPage ? 1 : this.pagination.currentPage;
      vm.pageSize = this.pageSize;

      await this.$ApiGet(`api/rlvEvidence/submittedDocuments`, vm).then(
        (res) => {
          this.results = res.data.data;
          this.pagination.count = this.pageSize;
          this.pagination.totalItemCount = res.data.totalItemCount;
          this.pagination.pageCount = Math.ceil(
            this.pagination.totalItemCount / this.pageSize
          );

          this.refreshPage = resetPage;
        }
      );
    },
    refreshSearch() {
      this.search(this.filters, false);
    },
    goToPage(page) {
      this.pagination.currentPage = page;
      this.search(this.filters, false);
    },
  },
  mounted() {},
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ['rlvevidence', 'rlvHistory'];

    next((vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.recoveryData();
        vm.search(vm.filters, vm.pagination.currentPage);
      } else {
        vm.shouldRecovery = false;
        vm.showAdvanced = false;
        vm.filters = {};
      }
    });
  },
};
</script>
